import cn from 'classnames';

import Text from 'components/common/Text';
import styles from 'styles/components/signUpFunnel/box/TempoBoxBanner.module.scss';

const TempoBoxBanner = () => {
  return (
    <div
      className={cn(
        styles.background,
        'mt-6 flex items-center justify-center rounded-2xl border border-solid border-charcoal-60 bg-tempo-gray-40 px-6 pb-2 pt-0 bp1:h-60 bp1:px-0 bp1:pb-4'
      )}
    >
      <div className="my-auto flex h-36 flex-col items-center justify-center text-center bp1:py-0">
        <Text brandStylesOverrides="h5 text-tempo-black-100">Over</Text>
        <Text brandStylesOverrides="text-tempo-blue-90 h1" className="mb-2">
          822,000
        </Text>
        <Text brandStylesOverrides=" text-tempo-black-100 h5">boxes delivered since 2023</Text>
      </div>
    </div>
  );
};

export default TempoBoxBanner;
